import * as THREE from 'three';

const ZOOM_MAX = 1.2;
const ZOOM_MAX_ANIMATE = 1.15;
const ZOOM_MIN = 2.4;

export function Zoom ( object, domElement ) {
    this.object = object;
    this.domElement = ( domElement === undefined ) ? document : domElement; // eslint-disable-line no-undefined

    // API
    this.zoomSpeed = 1.2;
    this.noZoom = false;
    this.dynamicDampingFactor = 0.2;

    this.preZoom = object.position.z;
    this.diffZoom = 0;

    this.fromScale = null;
    this.scaling = false;

    // internals
    this.target = new THREE.Vector3();

    const _eye = new THREE.Vector3(),
        _zoomStart = new THREE.Vector2(),
        _zoomEnd = new THREE.Vector2();

    // listeners
    const mousewheel = ( event ) => {
        if ( this.noZoom === true ) return;
        event.preventDefault();
        event.stopPropagation();
        // console.log('mousewheeling');

        /* enable two fingers move upward and downwards for zoom*/
        // if(Math.abs(event.deltaX) > 0 || Math.abs(event.deltaY) > 20) return;
        if(Math.abs(event.deltaMode) !== 0) return;

        _zoomStart.y -= event.deltaY * 0.00025;

    };

    this.touching = (distance, direction) => {
        const moveY = distance / 100 * 0.0005;

        if(direction === 'contracting') {
            _zoomStart.y -= moveY;
        }else {
            _zoomStart.y += moveY;
        }
    };

    this.scaleUp = () => {
        this.fromScale = _eye.z;
        this.scaling = true;
        this.scaleDirection = 'up';
    };

    this.scaleDown = () => {
        this.scaling = true;
        this.scaleDirection = 'down';
    };

    // methods
    this.zoomCamera = () => {
        let factor = 1.0 + ( _zoomEnd.y - _zoomStart.y ) * this.zoomSpeed;
        const v = new THREE.Vector3();
        if ( factor !== 1.0 && factor > 0.0 ) {

            v.copy(_eye);
            v.multiplyScalar( factor );

            if(v.z < ZOOM_MAX) {
                v.z = ZOOM_MAX;
                factor = 1;
            }

            if(v.z > ZOOM_MIN) {
                v.z = ZOOM_MIN;
                factor = 1;
            }

            _eye.multiplyScalar( factor );

        }
        _zoomStart.y += ( _zoomEnd.y - _zoomStart.y ) * this.dynamicDampingFactor;
    };

    // methods
    this.update = () => {

        this.diffZoom = this.object.position.z - this.preZoom;
        _eye.subVectors( this.object.position, this.target );

        if (!this.noZoom) {
            this.zoomCamera();
        }

        if( this.scaling ) {
            this.animateScale()
        }

        this.preZoom = this.object.position.z;
        this.object.position.addVectors( this.target, _eye );
        this.object.lookAt( this.target );
    };

    this.animateScale = () => {
        let zoomDelta;
        if( this.scaleDirection === 'up') {
            zoomDelta = (ZOOM_MAX_ANIMATE - _eye.z) * 0.08;
        }else {
            zoomDelta = (this.fromScale - _eye.z) * 0.08;
        }
        _eye.z +=  zoomDelta;

        if(Math.abs(zoomDelta) <= 0.001) {
            this.scaling = false;
        }
    };

    this.getEyePosition = () => this.diffZoom;

    this.dispose = () => {
        this.domElement.removeEventListener( 'mousewheel', mousewheel, false );
    };

    if(!TOUCH_SCREEN) {
        this.domElement.addEventListener( 'mousewheel', mousewheel, false );
    }

    // force an update at start
    this.update();
}
